export default "__VITE_ASSET__BxiGOjkL__"